export const USER_ROLES = ['student', 'clinic_staff', 'doctor', 'admin'];
export const ACADEMIC_YEARS = ['year_1', 'year_2', 'year_3', 'year_4', 'year_5', 'graduate'];
export const ACADEMIC_YEAR_LABELS = {
    year_1: 'Year 1',
    year_2: 'Year 2',
    year_3: 'Year 3',
    year_4: 'Year 4',
    year_5: 'Year 5',
    graduate: 'Graduate',
};
export const USER_STATUSES = ['active', 'suspended'];
export const APPROVAL_STATUSES = ['pending', 'approved', 'rejected'];
export const SUBSCRIPTION_STATUSES = ['pending', 'active', 'frozen', 'expired', 'cancelled'];
export const FREEZE_STATUSES = ['requested', 'approved', 'rejected'];
export const PAYMENT_STATUSES = ['pending', 'paid', 'failed', 'refunded'];
export const PAYMENT_METHODS = ['instapay', 'card', 'wallet'];
export const DISCOUNT_TYPES = ['percent', 'flat'];
export const USAGE_LIMIT_TYPES = ['total', 'unlimited', 'once_per_student'];
export const BOOKING_STATUSES = ['booked', 'scheduled', 'completed', 'cancelled'];
export const CONSULTATION_STATUSES = ['pending', 'answered', 'expired', 'declined'];
export const CONSULTATION_MODERATION_STATUSES = ['pending_review', 'approved', 'declined'];
export const REFERRAL_EVENT_TYPES = ['registered', 'subscribed'];
export const WITHDRAWAL_SOURCES = ['consultations', 'referrals', 'clinic_weeks'];
export const WITHDRAWAL_STATUSES = ['requested', 'paid', 'rejected'];
/** Admin dashboard modules. Permissions are stored as (module, action) rows. */
export const ADMIN_MODULES = [
    'dashboard',
    'statistics',
    'students',
    'clinics',
    'doctors',
    'internships',
    'subscriptions',
    'payments',
    'consultations',
    'certificates',
    'referrals',
    'promo_codes',
    'withdrawals',
    'events',
    'blogs',
    'settings',
    'permissions',
];
/**
 * Only `access` is issued today. The storage shape is (admin, module, action)
 * so view/edit/delete can be added later as data, without a migration.
 */
export const ADMIN_ACTIONS = ['access', 'view', 'edit', 'delete'];
export const ADMIN_MODULE_LABELS = {
    dashboard: 'Dashboard',
    statistics: 'Statistics',
    students: 'Students',
    clinics: 'Clinics',
    doctors: 'Doctors',
    internships: 'Internships',
    subscriptions: 'Subscriptions & Plans',
    payments: 'Payments',
    consultations: 'Consultations',
    certificates: 'Certificates',
    referrals: 'Referrals',
    promo_codes: 'Promo Codes',
    withdrawals: 'Withdrawal Requests',
    events: 'Events',
    blogs: 'Blogs',
    settings: 'Settings',
    permissions: 'Permissions',
};
//# sourceMappingURL=enums.js.map